import createLucideIcon from '../createLucideIcon';

const Type = createLucideIcon('TypeIcon', [
  ['polyline', { points: '4 7 4 4 20 4 20 7', key: '1nosan' }],
  ['line', { x1: '9', y1: '20', x2: '15', y2: '20', key: '10hqwk' }],
  ['line', { x1: '12', y1: '4', x2: '12', y2: '20', key: '8v58sd' }],
]);

export default Type;
